module.exports = __webpack_public_path__ + "media/images/projects/11-logo-02348dae1a8d6001543d149f63e7af2a.png";